/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'animate.css/animate.min.css';

import CSSModules from 'react-css-modules';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import PageLoading from 'loracoms/PageLoading';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { allSuccess } from 'lorautils/api/status';
import UnderCommercialView from './coms/UnderCommercialView';
import CommercialView from './coms/CommercialView';
import styles from './styles/main.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  plan: React.PropTypes.object.isRequired,
  basic: React.PropTypes.object.isRequired,
};

class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bills: [],
      plan: props.plan,
      basic: props.basic,
    };
    this.intlMsg = new IntlMsg(props.intl, 'billing');
  }

  componentWillReceiveProps(nextProps) {
    const { plan, basic } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderExpire() {
    const { plan: { data: planData } } = this.state;
    if (planData.expired) {
      return (
        <div styleName="expired-notify-wrapper">
          <div styleName="expired-notify" className="animated fadeInDown">
            <i className="fa fa-exclamation-circle" />
            {' '}
            {this.intlMsg.msg('expired.notify')}
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { plan, basic } = this.state;
    if (!allSuccess(plan, basic)) {
      return <PageLoading />;
    }
    let content = null;
    if (plan.data.tier === 3) {
      content = <CommercialView />;
    } else {
      content = <UnderCommercialView />;
    }

    return (
      <div>
        {this.renderExpire()}
        <div styleName="wrapper" style={{ minHeight: window.innerHeight - 50 }}>
          {content}
        </div>
      </div>
    );
  }
}

Billing.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
  basic: state.org.basic,
});

export default connect(mapStateToProps, null)(
  injectIntl(CSSModules(Billing, styles)));




// WEBPACK FOOTER //
// ./src/containers/Billing/index.jsx